<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-row no-gutters>
        <v-col cols="12" class="mb-6">
          <v-row no-gutters>
            <v-col cols="12">
              <v-row align="center" no-gutters>
                <div class="icon-container mr-3">
                  <v-icon size="28" color="turquisePanda">
                    mdi-chart-line
                  </v-icon>
                </div>
                <span class="font-weight-regular text-capitalize title">
                  Ranking
                </span>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-card class="mr-4" width="250px" flat>
          <date-picker
            :shortcuts="shortcuts"
            :clearable="false"
            :disabled-date="verifyDisabledDate"
            style="width: 100%"
            v-model="dateRange"
            confirm
            @change="getAccountRanking"
            hide-details
          >
            <template v-slot:input>
              <v-text-field
                label="Data"
                dense
                :value="dateRangeValue"
                outlined
                prepend-inner-icon="mdi-calendar"
                readonly
              ></v-text-field>
            </template>
            <template v-slot:icon-calendar>
              <v-icon style="display: none">mdi-calendar</v-icon>
            </template>
          </date-picker>
        </v-card>
      </v-row>
    </v-col>
    <v-row no-gutters v-if="rankLoading">
      <loading-logo :value="200" />
    </v-row>
    <v-row v-else no-gutters>
      <v-col cols="12" v-if="!rankLoading">
        <v-card flat height="40px">
          <v-row no-gutters>
            <v-col class="d-flex align-center justify-start pl-4">
              <v-hover v-slot="{ hover }">
                <v-row no-gutters @click="handleOrderByName">
                  <span class="caption mt-1 ml-8" style="height: 24px">
                    <b>{{ $t('message.pages.videosDataTable.header.name') }}</b>
                  </span>
                  <v-icon v-if="hover && !nameOrder" color="grey lighten-1"
                    >mdi-menu-down</v-icon
                  >
                  <v-icon v-if="hover && nameOrder === 'desc'"
                    >mdi-menu-down</v-icon
                  >
                  <v-icon v-if="hover && nameOrder === 'asc'"
                    >mdi-menu-up</v-icon
                  >
                </v-row>
              </v-hover>
            </v-col>
            <v-card
              class="d-flex align-center justify-center"
              height="45px"
              flat
              width="130px"
            >
              <v-hover v-slot="{ hover }">
                <v-row
                  no-gutters
                  @click="handleOrderByViews"
                  align="center"
                  justify="center"
                >
                  <span class="caption">
                    <b>{{ $t('message.pages.video.metricsPage.views') }}</b>
                  </span>
                  <v-icon v-if="hover && !viewsOrder" color="grey lighten-1"
                    >mdi-menu-down</v-icon
                  >
                  <v-icon v-if="hover && viewsOrder === 'desc'"
                    >mdi-menu-down</v-icon
                  >
                  <v-icon v-if="hover && viewsOrder === 'asc'"
                    >mdi-menu-up</v-icon
                  >
                </v-row>
              </v-hover>
            </v-card>
            <v-card
              class="d-flex align-center justify-center"
              height="45px"
              flat
              width="130px"
            >
              <v-hover v-slot="{ hover }">
                <v-row
                  no-gutters
                  @click="handleOrderByPlays"
                  align="center"
                  justify="center"
                >
                  <span class="caption">
                    <b>Plays</b>
                  </span>
                  <v-icon v-if="hover && !viewsOrder" color="grey lighten-1"
                    >mdi-menu-down</v-icon
                  >
                  <v-icon v-if="hover && viewsOrder === 'desc'"
                    >mdi-menu-down</v-icon
                  >
                  <v-icon v-if="hover && viewsOrder === 'asc'"
                    >mdi-menu-up</v-icon
                  >
                </v-row>
              </v-hover>
            </v-card>
            <v-card
              class="d-flex align-center justify-center mr-2"
              height="45px"
              flat
              width="170px"
            >
              <v-hover v-slot="{ hover }">
                <v-row
                  no-gutters
                  @click="handleOrderByUniqueViews"
                  align="center"
                  justify="center"
                >
                  <span class="caption">
                    <b>{{
                      $t('message.pages.video.metricsPage.uniqueViews')
                    }}</b>
                  </span>
                  <v-icon v-if="hover && !viewsOrder" color="grey lighten-1"
                    >mdi-menu-down</v-icon
                  >
                  <v-icon v-if="hover && viewsOrder === 'desc'"
                    >mdi-menu-down</v-icon
                  >
                  <v-icon v-if="hover && viewsOrder === 'asc'"
                    >mdi-menu-up</v-icon
                  >
                </v-row>
              </v-hover>
            </v-card>

            <v-card
              class="d-flex align-center justify-center mr-2"
              height="45px"
              flat
              width="170px"
            >
              <v-hover v-slot="{ hover }">
                <v-row
                  no-gutters
                  @click="handleOrderByUniquePlays"
                  align="center"
                  justify="center"
                >
                  <span class="caption">
                    <b>{{
                      $t('message.pages.video.metricsPage.uniquePlays')
                    }}</b>
                  </span>
                  <v-icon
                    v-if="hover && !uniquePlaysOrder"
                    color="grey lighten-1"
                    >mdi-menu-down</v-icon
                  >
                  <v-icon v-if="hover && uniquePlaysOrder === 'desc'"
                    >mdi-menu-down</v-icon
                  >
                  <v-icon v-if="hover && uniquePlaysOrder === 'asc'"
                    >mdi-menu-up</v-icon
                  >
                </v-row>
              </v-hover>
            </v-card>
          </v-row>
        </v-card>
      </v-col>
      <vue-virtual-table
        v-if="tableArray.length > 0"
        :data="tableArray"
        :config="headers"
        :height="800"
        :itemHeight="48"
        :minWidth="770"
        class="pointerTable"
        :class="{
          virtualTable: $vuetify.theme.dark,
        }"
      >
        <template slot-scope="scope" slot="nameCommon">
          <v-row
            no-gutters
            class="pl-3 pt-1"
            style="max-width: 100%"
            @click="handleEditVideo(scope.row)"
          >
            <span :title="scope.row.title" class="text-truncate">
              <v-icon color="turquisePanda" class="pr-1 pb-1">
                mdi-play-circle-outline
              </v-icon>
              {{ scope.row.title }}
            </span>
          </v-row>
        </template>
        <template slot-scope="scope" slot="view">
          <v-row
            no-gutters
            justify="center"
            @click="handleEditVideo(scope.row)"
          >
            <span class="text-right">{{
              Number(scope.row.view).toLocaleString()
            }}</span>
          </v-row>
        </template>
        <template slot-scope="scope" slot="play">
          <v-row
            no-gutters
            justify="center"
            @click="handleEditVideo(scope.row)"
          >
            <span class="text-right">{{
              Number(scope.row.play).toLocaleString()
            }}</span>
          </v-row>
        </template>
        <template slot-scope="scope" slot="uniqueView">
          <v-row
            no-gutters
            @click="handleEditVideo(scope.row)"
            justify="end"
            class="pr-16"
          >
            <span class="text-right">{{
              Number(scope.row.unique_view).toLocaleString()
            }}</span>
          </v-row>
        </template>
        <template slot-scope="scope" slot="uniquePlay">
          <v-row
            no-gutters
            @click="handleEditVideo(scope.row)"
            justify="end"
            class="pr-16"
          >
            <span class="text-right">{{
              Number(scope.row.unique_play).toLocaleString()
            }}</span>
          </v-row>
        </template>
      </vue-virtual-table>
      <v-row v-else no-gutters align="center" justify="center">
        <v-col cols="12" class="mb-16">
          <v-row
            class="d-flex flex-column"
            no-gutters
            justify="center"
            align="center"
          >
            <img
              v-if="$vuetify.theme.dark"
              class="ml-4"
              src="@/assets/pandaLogo.svg"
              max-width="180"
            />
            <img
              v-else
              class="ml-4"
              src="@/assets/pandaHappy.svg"
              max-width="180"
            />
            <span class="noFilesAddedText">
              {{ $t('message.pages.video.metricsPage.rankTable.noInfoFound') }}
            </span>
          </v-row>
        </v-col>
      </v-row>
    </v-row>
  </v-row>
</template>

<script>
import LoadingLogo from '@/components/LoadingLogo.vue'
import VueVirtualTable from 'vue-virtual-table'
import analyticsApi from '@/services/analyticsApi'
import i18n from '@/translations/lang'
import { subDays, subMonths, isBefore, format } from 'date-fns'
import DatePicker from 'vue2-datepicker'
import { mapMutations } from 'vuex'

export default {
  name: 'RankTable',
  components: {
    LoadingLogo,
    DatePicker,
    VueVirtualTable,
  },
  data: () => ({
    rankLoading: false,
    tableArray: [],
    headers: [
      {
        prop: '_action',
        name: 'Nome',
        actionName: 'nameCommon',
        alignItems: 'start',
      },
      {
        prop: '_action',
        actionName: 'view',
        alignItems: 'center',
        width: 120,
      },
      {
        prop: '_action',
        actionName: 'play',
        alignItems: 'center',

        width: 150,
      },
      {
        prop: '_action',
        actionName: 'uniqueView',
        alignItems: 'center',
        width: 150,
      },
      {
        prop: '_action',
        actionName: 'uniquePlay',
        alignItems: 'center',
        width: 180,
      },
    ],
    shortcuts: [
      {
        text: i18n.t('message.pages.video.metricsPage.datepicker.today'),
        onClick() {
          const date = new Date()
          return date
        },
      },
      {
        text: i18n.t('message.pages.video.metricsPage.datepicker.yesterday'),
        onClick() {
          const date = new Date()
          return subDays(date, 1)
        },
      },
      {
        text: i18n.t('message.pages.video.metricsPage.datepicker.7days'),
        onClick() {
          const date = new Date()
          return subDays(date, 7)
        },
      },
      {
        text: i18n.t('message.pages.video.metricsPage.datepicker.aMonth'),
        onClick() {
          const date = new Date()
          return subMonths(date, 1)
        },
      },
    ],
    dateRange: new Date(),
    wasFetch: false,
    viewsOrder: 'asc',
    playsOrder: 'asc',
    uniqueViewsOrder: 'asc',
    uniquePlaysOrder: 'asc',
    nameOrder: 'asc',
  }),
  computed: {
    dateRangeValue() {
      return `${format(this.dateRange, 'dd/MM/yyyy')}`
    },
  },
  async created() {
    this.dateRange = this.dateRange.setDate(this.dateRange.getDate() - 1)
    this.getAccountRanking()
  },
  methods: {
    ...mapMutations('user', ['UPDATE_ROUTED_VIDEO']),
    handleOrderByName() {
      if (!this.nameOrder || this.nameOrder === 'desc') {
        this.nameOrder = 'asc'
      } else {
        this.nameOrder = 'desc'
      }
      if (this.nameOrder === 'asc') {
        this.tableArray.sort((a, b) =>
          a.title.localeCompare(b.title, undefined, { numeric: true })
        )
      }
      if (this.nameOrder === 'desc') {
        this.tableArray.sort(
          (a, b) =>
            -a.title.localeCompare(b.title, undefined, { numeric: true })
        )
      }
    },
    handleOrderByViews() {
      if (!this.viewsOrder || this.viewsOrder === 'desc') {
        this.viewsOrder = 'asc'
      } else {
        this.viewsOrder = 'desc'
      }
      if (this.viewsOrder === 'asc') {
        this.tableArray.sort((a, b) => a.value - b.value)
      }
      if (this.viewsOrder === 'desc') {
        this.tableArray.sort((a, b) => b.value - a.value)
      }
    },
    handleOrderByPlays() {
      if (!this.playsOrder || this.playsOrder === 'desc') {
        this.playsOrder = 'asc'
      } else {
        this.playsOrder = 'desc'
      }
      if (this.playsOrder === 'asc') {
        this.tableArray.sort((a, b) => a.play - b.play)
      }
      if (this.playsOrder === 'desc') {
        this.tableArray.sort((a, b) => b.play - a.play)
      }
    },
    handleOrderByUniqueViews() {
      if (!this.uniqueViewsOrder || this.uniqueViewsOrder === 'desc') {
        this.uniqueViewsOrder = 'asc'
      } else {
        this.uniqueViewsOrder = 'desc'
      }
      if (this.uniqueViewsOrder === 'asc') {
        this.tableArray.sort((a, b) => a.unique_view - b.unique_view)
      }
      if (this.uniqueViewsOrder === 'desc') {
        this.tableArray.sort((a, b) => b.unique_view - a.unique_view)
      }
    },
    handleOrderByUniquePlays() {
      if (!this.uniquePlaysOrder || this.uniquePlaysOrder === 'desc') {
        this.uniquePlaysOrder = 'asc'
      } else {
        this.uniquePlaysOrder = 'desc'
      }
      if (this.uniquePlaysOrder === 'asc') {
        this.tableArray.sort((a, b) => a.unique_play - b.unique_play)
      }
      if (this.uniquePlaysOrder === 'desc') {
        this.tableArray.sort((a, b) => b.unique_play - a.unique_play)
      }
    },
    verifyDisabledDate(date) {
      let newDate = new Date()
      let yesterday = newDate.setDate(newDate.getDate() - 1)
      const canUse = !isBefore(date, yesterday)
      return canUse
    },
    async handleEditVideo(video) {
      this.$router.push({ name: 'VideoPage', params: { id: video.id } })
    },
    async getAccountRanking() {
      this.rankLoading = true
      this.wasFetch = false
      try {
        let ret = await analyticsApi.getRankingV2(
          format(this.dateRange, 'yyyy-MM-dd')
        )
        this.tableArray = ret.data.map((item) => {
          if (!item.play) {
            item.play = 0
          }
          if (!item.unique_play) {
            item.unique_play = 0
          }
          if (!item.unique_view) {
            item.unique_view = 0
          }
          return item
        })
      } catch (e) {
        this.rankLoading = false
        console.log('e', e)
      }
      this.wasFetch = true
      this.rankLoading = false
    },
  },
}
</script>
<style lang="scss">
.t-header {
  display: none;
}

.t-header span {
  font-weight: bold;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none;
}

.pointerTable {
  cursor: pointer;
}
</style>
